export default function SubmitButton({disabled, label}) {
    if (!label) label = "Enregistrer";
    return (
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <input disabled={disabled} class="action-button btn btn-primary btn-lg position-fixed bottom-0 end-0 me-3 mb-3" type="submit" value={label} />
        </div>
    );
}